import React from 'react';
import { RouteObject } from 'react-router-dom';
import {
  contractRoute,
  dashboardIndexRoute,
  dashboardRoute,
  employeePrintRoute,
  employeesRoute,
  employerRefRoute,
  ertnRoute,
  ratesRoute,
  reportsRoute,
  schedulesRoute,
  userAgreementRoute,
  maintenanceRoute,
  retroPayRoute,
} from '@/root-app/app-routes/routes';
import RootApp from '@/root-app/RootApp';
import { ROUTE_NAMES } from '@/core/routes/routeNames';
import RoutingErrorPage from '@/components/Error/RoutingErrorPage';

const EmployerUserRoutes: RouteObject = {
  path: ROUTE_NAMES.ROOT,
  Component: RootApp,
  errorElement: <RoutingErrorPage />,
  children: [
    dashboardIndexRoute,
    userAgreementRoute,
    dashboardRoute,
    schedulesRoute,
    employeesRoute,
    contractRoute,
    employerRefRoute,
    ertnRoute,
    reportsRoute,
    employeePrintRoute,
    ratesRoute,
    maintenanceRoute,
    retroPayRoute,
  ],
};

export default EmployerUserRoutes;
